import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import instance from '../../services/services';
import { LIKE_URL } from '../../utils/urls';
import useUserStore from '../../store/userStore';
import { formatLocalString } from '../../utils/validation';
import PopupLoginError from '../Popup/LoginError';
// import leftArrow from '../../assets/icon/left-arrow.png';
// import rightArrow from '../../assets/icon/right-arrow.png';
import truck from '../../assets/icon/mingcute--truck-line.svg';
import store from '../../assets/icon/mingcute--store-line.svg';

const WideProduct = ({ product }) => {
  const navigate = useNavigate();
  const [isActive, setIsActive] = useState(!!product.goods_like_seq);
  const { memberTokens, userInfo } = useUserStore();
  const [isPopupLoginError, setIsPopupLoginError] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // 고유 ID 생성
  // const uniqueId = `wide-${product.goods_seq}`;

  // 중복된 useEffect 제거하고 하나로 통합
  useEffect(() => {
      const checkMobile = () => {
          const mobile = window.innerWidth < 1280;
          setIsMobile(mobile);
      };
      
      checkMobile(); // 초기 실행
      window.addEventListener('resize', checkMobile);
      
      return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // 팝업 확인 버튼 클릭 핸들러 (조건부 로직 추가)
  const handleConfirm = () => {
    // isPopupLoginError가 객체이고 action 속성이 'navigate_login'인 경우에만 로그인 페이지로 이동
    if (isPopupLoginError && isPopupLoginError.action === 'navigate_login') {
        navigate('/login');
    }
    // 그 외의 경우는 단순히 팝업만 닫음
    setIsPopupLoginError(false);
};

  const handleProductDetail = (product) => {
    // group_label_txt가 있으면 팝업 표시
  //   if (product.group_label_txt) {
  //     setIsPopupLoginError({
  //         message: "고객센터로 문의바랍니다.",
  //         action: null // 로그인 페이지로 이동하지 않음
  //     });
  //     return;
  // }

    navigate(`/product/detail/${product.goods_seq}`);
};

  const handleWishBtnClick = async (e) => {
    e.stopPropagation(); // 상위 요소로의 이벤트 전파 방지
    
    // 로그인 확인
    if (!memberTokens) {
        alert('로그인이 필요한 서비스입니다.');
        navigate('/login');
        return;
    }

    try {
        // LIKE_URL에 POST 요청 보내기
        const response = await instance.post(LIKE_URL, {
            goods_seq: product.goods_seq,
            member_seq: userInfo.member_seq
        });
        
        // 응답이 성공적인 경우
        if (response.data.code === 200) {
            setIsActive(!isActive); // 토글 기능 추가
        } else {
            console.error('좋아요 상태 변경 실패:', response.data);
        }
    } catch (error) {
        console.error('좋아요 API 호출 중 오류 발생:', error);
    }
  };

  // 데스크톱용 컴포넌트 렌더링 함수 (768px 초과에서만 사용)
  // const renderThumbnails = () => {
  //   const thumbnails = product.package_view_thumbnails || [];
    
  //   if (thumbnails.length > 6) {
  //     // 6개 초과일 때 스와이퍼 사용
  //     return (
  //       <div className='wide_compo' style={{ position: 'relative', overflow: 'hidden' }}>
  //         <Swiper
  //           modules={[Navigation]}
  //           spaceBetween={4}
  //           slidesPerView={6}
  //           navigation={{
  //             nextEl: `.swiper-button-next-${uniqueId}`, // 고유 클래스명 사용
  //             prevEl: `.swiper-button-prev-${uniqueId}`, // 고유 클래스명 사용
  //           }}
            
  //         >
  //           {thumbnails.map((thumbnail, idx) => (
  //             <SwiperSlide key={idx}>
  //               <div className="compo_box">
  //                 <img src={thumbnail} alt="component" loading="lazy"/>
  //               </div>
  //             </SwiperSlide>
  //           ))}
  //         </Swiper>
          
  //         {/* 고유한 클래스명으로 변경 */}
  //         <div 
  //           className={`swiper-button-prev-${uniqueId}`}
  //           style={{
  //             position: 'absolute',
  //             left: '2px',
  //             top: '50%',
  //             transform: 'translateY(-50%)',
  //             cursor: 'pointer',
  //             zIndex: 10,
  //             transition: 'all 0.3s ease',
  //             userSelect: 'none',
  //           }}
  //           onClick={(e) => {
  //             e.stopPropagation();
  //           }}
  //         >
  //           <img 
  //             src={leftArrow} 
  //             alt="이전" 
  //             style={{
  //               width: '20px',
  //               height: '20px',
  //               pointerEvents: 'none'
  //             }}
  //           />
  //         </div>
          
  //         <div 
  //           className={`swiper-button-next-${uniqueId}`}
  //           style={{
  //             position: 'absolute',
  //             right: '2px',
  //             top: '50%',
  //             transform: 'translateY(-50%)',
  //             cursor: 'pointer',
  //             zIndex: 10,
  //             transition: 'all 0.3s ease',
  //             userSelect: 'none',
  //           }}
  //           onClick={(e) => {
  //             e.stopPropagation();
  //           }}
  //         >
  //           <img 
  //             src={rightArrow} 
  //             alt="다음" 
  //             style={{
  //               width: '20px',
  //               height: '20px',
  //               pointerEvents: 'none'
  //             }}
  //           />
  //         </div>
  //       </div>
  //     );
  //   } else {
  //     // 6개 이하일 때 기존 방식 사용 (화살표 없음)
  //     return (
  //       <div className='wide_compo'>
  //         {thumbnails.map((thumbnail, idx) => (
  //           <div className="compo_box" key={idx}>
  //             <img src={thumbnail} alt="component" loading="lazy"/>
  //           </div>
  //         ))}
  //       </div>
  //     );
  //   }
  // };

  // 모바일용 썸네일 렌더링 함수 수정
  // const renderMobileThumbnails = () => {
  //   const thumbnails = product.package_view_thumbnails || [];
  //   const mobileUniqueId = `mobile-${product.goods_seq}`;
    
  //   return (
  //     <div className='wide_list_img mobile-swiper' style={{ position: 'relative', overflow: 'hidden' }}>
  //       <Swiper
  //         modules={[Navigation]}
  //         spaceBetween={8}
  //         slidesPerView={3}
  //         navigation={{
  //           nextEl: `.swiper-button-next-${mobileUniqueId}`,
  //           prevEl: `.swiper-button-prev-${mobileUniqueId}`,
  //         }}
  //         // breakpoints={{
  //         //   0: {
  //         //     slidesPerView: 3,
  //         //     spaceBetween: 8,
  //         //   },
  //         //   768: {
  //         //     slidesPerView: 4,
  //         //     spaceBetween: 8,
  //         //   },
  //         //   1024: {
  //         //     slidesPerView: 5,
  //         //     spaceBetween: 8,
  //         //   },
  //         //   1200: {
  //         //     slidesPerView: 6,
  //         //     spaceBetween: 8,
  //         //   }
  //         // }}
  //       >
  //         {thumbnails.map((thumbnail, idx) => (
  //           <SwiperSlide key={idx}>
  //             <div className="compo_box">
  //               <img src={thumbnail} alt="component" loading="lazy"/>
  //             </div>
  //           </SwiperSlide>
  //         ))}
  //       </Swiper>
        
  //       {/* 모바일용 고유한 클래스명으로 변경 */}
  //       {/* <div 
  //         className={`swiper-button-prev-${mobileUniqueId}`}
  //         style={{
  //           position: 'absolute',
  //           left: '2px',
  //           top: '50%',
  //           transform: 'translateY(-50%)',
  //           cursor: 'pointer',
  //           zIndex: 10,
  //           backgroundColor: 'rgba(255, 255, 255, 0.8)',
  //           borderRadius: '50%',
  //           width: '24px',
  //           height: '24px',
  //           display: 'flex',
  //           alignItems: 'center',
  //           justifyContent: 'center',
  //           boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
  //         }}
  //         onClick={(e) => {
  //           e.stopPropagation();
  //         }}
  //       >
  //         <img 
  //           src={leftArrow} 
  //           alt="이전" 
  //           style={{
  //             width: '12px',
  //             height: '12px',
  //             pointerEvents: 'none'
  //           }}
  //         />
  //       </div> */}
        
  //       {/* <div 
  //         className={`swiper-button-next-${mobileUniqueId}`}
  //         style={{
  //           position: 'absolute',
  //           right: '2px',
  //           top: '50%',
  //           transform: 'translateY(-50%)',
  //           cursor: 'pointer',
  //           zIndex: 10,
  //           backgroundColor: 'rgba(255, 255, 255, 0.8)',
  //           borderRadius: '50%',
  //           width: '24px',
  //           height: '24px',
  //           display: 'flex',
  //           alignItems: 'center',
  //           justifyContent: 'center',
  //           boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
  //         }}
  //         onClick={(e) => {
  //           e.stopPropagation();
  //         }}
  //       >
  //         <img 
  //           src={rightArrow} 
  //           alt="다음" 
  //           style={{
  //             width: '12px',
  //             height: '12px',
  //             pointerEvents: 'none'
  //           }}
  //         />
  //       </div> */}
  //     </div>
  //   );
  // };

  // 1280px 미만: 모바일 UI (스와이퍼 적용)
  if (isMobile) {
    return(
      <div>
        {/* 모바일/태블릿 - 기존 스타일 그대로 유지 */}
        <div
          className="default_prod prod_item"
          onClick={() => handleProductDetail(product)}
          style={{ marginTop: '12px'}}
        >
          <div style={{ display: 'flex'}}>

            <div style={{ position:"relative", flex: '1' }}>
              <div className="border-text-box">ID {product?.goods_code}</div>
              <div className="prod_img wide_img">
                  <div
                      className="wish_box"
                      onClick={handleWishBtnClick}
                  >
                    <button type="button" className={`wish_btn ${isActive ? 'active' :''}`}/>
                    {product?.order_visit_flag === 'Y' && (
                        <div >
                            <img src={store} alt="store" />
                        </div>
                    )}
                    {product?.order_parcel_flag === 'Y' && (
                        <div>
                            <img src={truck} alt="truck" />
                        </div>
                    )}
                  </div>
                  <div className="brand_img">
                      <img src={product?.brand_goods_img} alt="red" />
                  </div>
                  <div className='product_img'>
                      <img src={product.goods_image[0]} alt="cannon_c500" loading="lazy"/>
                  </div>
                  {product.summary_flag === 'Y' && (
                    <p className={`${product.summary_color} special_phrase`} style={{backgroundColor: product?.summary_bg_color, color: product?.summary_txt_color, borderColor: product?.summary_border_color}}>
                        <span className="ellipsis1">
                            {product.summary_txt}
                        </span>
                    </p>
                )}
                {/* <p className="prod_type flex-center" style={{ flexWrap: 'wrap', rowGap: '4px' }}>
                  {product?.badgeList?.map((badge, idx) => (
                        <img key={idx} className={`badge_${badge}`} src={badge} alt={badge} loading="lazy"/>
                    ))}
                </p> */}

                <p className="prod_type flex-center" style={{ flexWrap: 'wrap', rowGap: '4px' }}>
                    {product?.badgeList?.map((badge, idx) => (
                        <span 
                            key={idx} 
                            className="badge_item"
                            style={{
                                backgroundColor: badge.badge_color_bg,
                                color: badge.badge_color_txt,
                                border: `1px solid ${badge.badge_color_border}`
                            }}
                        >
                            {badge.badge_name}
                        </span>
                    ))}
                </p>
              </div>
            </div>
            <div style={{ flex: '1' }}>
              <div className="prod_info" style={{ paddingTop: '50px' }}>
                <div className="prod_title" >
                  <p className="title ellipsis_clamp">
                    {product.goods_name}
                  </p>
                  <p className="sub_title ellipsis1">
                    {product.description_kr_01}
                  </p>
                </div>
                <div style={{ position: 'relative', width: '100%'}}>
                  {Number(product?.discount_rate) > 0 && (
                    <div className="border-prod_price">{product?.discount_rate}<span style={{fontSize:'11px'}}>%</span></div>
                  )}
                  
                  {product.goods_type === 'rental' ? (
                    <div className="prod_price">
                      {product.group_label_txt ? (
                        <div className="group_label">{product.group_label_txt}</div>
                      ) : (
                        <>
                          <div className="day half">
                            <div className="day_hour_price">
                              <span className="hour">12h </span>
                              <span className="price"><span className="price_won">₩</span>{formatLocalString(product.result_12_price || 0)} </span>
                            </div>
                            {Number(product?.discount_rate) > 0 && (
                              <span className="consumer_price">
                                <span className="consumer_price_won">₩</span>
                                <span className="line_through">{formatLocalString(product.rental_12_price || 0)}</span>
                              </span>
                            )}
                          </div>
                          <div className="day">
                            <div className="day_hour_price">
                              <span className="hour">24h</span>
                              <span className="price"><span className="price_won">₩</span>{formatLocalString(product.result_24_price || 0)} </span>
                            </div>
                            {Number(product?.discount_rate) > 0 && (
                              <span className="consumer_price">
                                <span className="consumer_price_won">₩</span>
                                <span className="line_through">{formatLocalString(product.rental_24_price || 0)}</span>
                              </span>
                            )}
                          </div>
                        </>
                      )}
                    </div>
                  ) : product.goods_type === 'sale' ? (
                    <div className="prod_price sale">
                      {product.group_label_txt ? (
                        <div className="group_label">{product.group_label_txt}</div>
                      ) : (
                        <>
                          <div className="day half">
                            <div className="day_hour_price">
                              <span className="price"><span className="price_won">₩</span>{formatLocalString(product.price || 0)} </span>
                            </div>
                            {Number(product?.discount_rate) > 0 && (
                              <div className="consumer_price">
                                <span className="consumer_price_won">₩</span>
                                <span className="line_through">{formatLocalString(product.unit_price || 0)}</span>
                              </div>
                            )}
                          </div>
                        </>
                      )}
                    </div>
                  ) : product.goods_type === 'package' ? (
                    <div className="prod_price">
                      {product.group_label_txt ? (
                        <div className="group_label">{product.group_label_txt}</div>
                      ) : (
                        <>
                          <div className="day half">
                            <div className="day_hour_price">
                              <span className="hour">12h</span>
                              <span className="price"><span className="price_won">₩</span>
                              {product?.discount_rate === "0" ? formatLocalString(product?.rental_12_price) : formatLocalString(product?.result_12_price)}
                              </span>
                            </div>
                            {Number(product?.discount_rate) > 0 && (
                              <span className="consumer_price">
                                <span className="consumer_price_won">₩</span>
                                <span className="line_through">{formatLocalString(product.rental_12_price || 0)}</span>
                              </span>
                            )}
                          </div>
                          <div className="day">
                            <div className="day_hour_price">
                              <span className="hour">24h</span>
                              <span className="price"><span className="price_won">₩</span>
                              {product?.discount_rate === "0" ? formatLocalString(product?.rental_24_price) : formatLocalString(product?.result_24_price)}
                              </span>
                            </div>
                            {Number(product?.discount_rate) > 0 && (
                              <div className="consumer_price">
                                <span className="consumer_price_won">₩</span>
                                <span className="line_through">{formatLocalString(product.rental_24_price || 0)}</span>
                              </div>
                            )}
                          </div>
                        </>
                      )}
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
          
          {/* 모바일에서 스와이퍼 적용 */}
          {/* {renderMobileThumbnails()} */}
        </div>
      </div>
    )
  }
  
  // 1600px 초과: 데스크톱 UI (조건부 스와이퍼)
  return (
    <div>
      {/* PC/큰 태블릿 - 조건부 스와이퍼 적용 */}
      <div
        className="default_prod prod_item wide_prod"
        onClick={() => handleProductDetail(product)}
      >
        <div style={{ display: 'flex'}}>
          <div className="border-text-box">ID {product?.goods_code}</div>

          <div style={{ flex: '1' }}>
            <div className="prod_img wide_img">
                <div
                    className="wish_box"
                    onClick={handleWishBtnClick}
                >
                    <button type="button" className={`wish_btn ${isActive ? 'active' :''}`}/>
                    {product?.order_visit_flag === 'Y' && (
                        <div >
                            <img src={store} alt="store" />
                        </div>
                    )}
                    {product?.order_parcel_flag === 'Y' && (
                        <div>
                            <img src={truck} alt="truck" />
                        </div>
                    )}
                </div>
                <div className="brand_img">
                    <img src={product?.brand_goods_img} alt="red" loading="lazy"/>
                </div>
                <div className='product_img'>
                    <img src={product.goods_image[0]} alt="cannon_c500" loading="lazy"/>
                </div>
                  {product.summary_flag === 'Y' && (
                    <p className={`${product.summary_color} special_phrase`} style={{backgroundColor: product?.summary_bg_color, color: product?.summary_txt_color, borderColor: product?.summary_border_color}}>
                        <span className="ellipsis1">
                            {product.summary_txt}
                        </span>
                    </p>
                )}
              {/* <p className="prod_type flex-center" style={{ flexWrap: 'wrap', rowGap: '4px' }}>
                {product?.badgeList?.map((badge, idx) => (
                      <img key={idx} className={`badge_${badge}`} src={badge} alt={badge} loading="lazy"/>
                  ))}
              </p> */}
              {/* 뱃지 */}
              <p className="prod_type flex-center" style={{ flexWrap: 'wrap', rowGap: '4px' }}>
                  {product?.badgeList?.map((badge, idx) => (
                      <span 
                          key={idx} 
                          className="badge_item"
                          style={{
                              backgroundColor: badge.badge_color_bg,
                              color: badge.badge_color_txt,
                              border: `1px solid ${badge.badge_color_border}`
                          }}
                      >
                          {badge.badge_name}
                      </span>
                  ))}
              </p>
            </div>
          </div>
          <div style={{ flex: '1.1' }}>
            <div className="prod_info" style={{ paddingTop: '50px' }}>
              <div className="prod_title">
                <p className="title ellipsis_clamp" >
                  {product.goods_name}
                </p>
                <p className="sub_title ellipsis1">
                  {product.description_kr_01}
                </p>
              </div>

              {product.goods_type === 'rental' ? (
              <div style={{ position: 'relative' }}>
                {Number(product?.discount_rate) > 0 && (
                  <div className="border-prod_price">{product?.discount_rate}<span style={{fontSize:'11px'}}>%</span></div>
                )}
                <div className="prod_price" >
                  {product.group_label_txt ? (
                    <div className="group_label">{product.group_label_txt}</div>
                  ) : (
                    <>
                      <div className="day half">
                        <div className="day_hour_price">
                          <span className="hour">12h </span>
                          <span className="price"><span className="price_won">₩</span>{formatLocalString(product.result_12_price || 0)} </span>
                        </div>
                        {product?.discount_rate > 0 && (
                          <div className="consumer_price">
                            <span className="consumer_price_won">₩</span>
                            <span className="line_through">{formatLocalString(product.rental_12_price || 0)}</span>
                          </div>
                        )}
                      </div>
                      <div className="day">
                        <div className="day_hour_price">
                          <span className="hour">24h</span>
                          <span className="price"><span className="price_won">₩</span>{formatLocalString(product.result_24_price || 0)} </span>
                        </div>
                        {product?.discount_rate > 0 && (
                        <span className="consumer_price">
                          <span className="consumer_price_won">₩</span>
                          <span className="line_through">{formatLocalString(product.result_24_price || 0)}</span>
                        </span>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
                ) : product.goods_type === 'sale' ? (
                    <div className="prod_price sale" style={{ position: 'relative' }}>
                        <div className="border-prod_price">{product?.discount_rate}<span style={{fontSize:'11px'}}>%</span></div>
                        {product.group_label_txt ? (
                    <div className="group_label">{product.group_label_txt}</div>
                  ): (
                      <>
                        <div className="day half">
                            <div className="day_hour_price">
                              <span className="price"><span className="price_won">₩</span>{formatLocalString(product.price || 0)} </span>
                            </div>
                            <div className="consumer_price">
                              <span className="consumer_price_won">₩</span>
                              <span className="line_through">{formatLocalString(product.unit_price || 0)}</span>
                          </div>
                        </div>
                      </>
                    )}
                    </div>
                ) : product.goods_type === 'package' ? (
                  <div style={{ position: 'relative' }}>
                    {Number(product?.discount_rate) > 0 && (
                      <div className="border-prod_price">{product?.discount_rate}<span style={{fontSize:'11px'}}>%</span></div>
                    )}
    
                    <div className="prod_price">
                      {product.group_label_txt ? (
                        <div className="group_label">{product.group_label_txt}</div>
                      ) : (
                        <>
                          <div className="day half">
                            <div className="day_hour_price">
                              <span className="hour">12h</span>
                              <span className="price"><span className="price_won">₩</span>
                              {product?.discount_rate === "0" ? formatLocalString(product?.rental_12_price) : formatLocalString(product?.result_12_price)}
                              </span>
                              
                            </div>
                            {Number(product?.discount_rate) > 0 && (
                            <span className="consumer_price">
                              <span className="consumer_price_won">₩</span>
                              <span className="line_through">{formatLocalString(product.rental_12_price || 0)}</span>
                            </span>
                            )}
                          </div>
                          <div className="day">
                            <div className="day_hour_price">
                              <span className="hour">24h</span>
                              <span className="price"><span className="price_won">₩</span>
                              {product?.discount_rate === "0" ? formatLocalString(product?.rental_24_price) : formatLocalString(product?.result_24_price)}
                              </span>
                            </div>
                            {Number(product?.discount_rate) > 0 && (
                            <div className="consumer_price">
                              <span className="consumer_price_won">₩</span>
                              <span className="line_through">{formatLocalString(product.rental_24_price || 0)}</span>
                            </div>
                            )}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                ) : null}
            </div>
          </div>
        </div>
        
        {/* 데스크톱에서만 조건부 스와이퍼 적용 */}
        {/* {renderThumbnails()} */}
      </div>

      <PopupLoginError 
        isPopup={isPopupLoginError} 
        setIsPopup={setIsPopupLoginError}
        onConfirm={handleConfirm}
      />
    </div>
  );
};

export default WideProduct;

